'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSortableHoc = require('react-sortable-hoc');

var _SortableHandle = require('./SortableHandle');

var _SortableHandle2 = _interopRequireDefault(_SortableHandle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SortableElement', function (theme) {
  return {
    sortableElement: {
      '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
      paddingRight: theme.typography.rhythmByUnit(6),
      userSelect: 'none',
      cursor: 'grab',
      fallbacks: {
        cursor: 'move'
      }
    }
  };
});

exports['default'] = (0, _reactSortableHoc.SortableElement)((_temp = _class = function (_PureComponent) {
  _inherits(SortableElement, _PureComponent);

  function SortableElement() {
    _classCallCheck(this, SortableElement);

    return _possibleConstructorReturn(this, (SortableElement.__proto__ || Object.getPrototypeOf(SortableElement)).apply(this, arguments));
  }

  _createClass(SortableElement, [{
    key: 'render',
    value: function () {
      function render() {
        var classes = this.context.styleManager.render(styleSheet);
        var elementProp = this.props.element;
        var _elementProp$props = elementProp.props;
        _elementProp$props = _elementProp$props === undefined ? {} : _elementProp$props;
        var className = _elementProp$props.className,
            _elementProp$type = elementProp.type;
        _elementProp$type = _elementProp$type === undefined ? {} : _elementProp$type;
        var _elementProp$type$pro = _elementProp$type.propTypes;
        _elementProp$type$pro = _elementProp$type$pro === undefined ? {} : _elementProp$type$pro;
        var actionsPropType = _elementProp$type$pro.actions;

        var element = _react2['default'].cloneElement(elementProp, Object.assign({}, actionsPropType && {
          actions: _react2['default'].createElement(_SortableHandle2['default'], null)
        }, {
          button: false,
          className: (0, _classnames2['default'])(classes.sortableElement, className, 'cursorGrabbing')
        }));
        return _react2['default'].createElement(
          'div',
          null,
          element
        );
      }

      return render;
    }()
  }]);

  return SortableElement;
}(_react.PureComponent), _class.propTypes = {
  element: _PropTypes2['default'].node
}, _class.displayName = 'SortableElement', _class.defaultProps = {
  element: null
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp), {
  withRef: true
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/makeSortable/SortableElement.js
// module id = 656
// module chunks = 32